import { AxiosResponse } from "axios";
import { Company, CompanyUserField, Equipment } from "../types/Company";
import { Department } from "../types/Department";
import { CompanyPermissionId } from "../types/Permissions";
import { User, WorktimeGroup } from "../types/User";
import agent from "./agent";

interface ImportUserData {
  email: string;
  roleId: 1 | 2 | 3;
  firstName: string;
  lastName: string;
  gender: string | null;
  dateBirth: string | null;
  citizenship: string | null;
  ssn: string | null;
  address: string | null;
  postalCode: string | null;
  city: string | null;
  country: string | null;
  phone: string | null;
  managerId: string | null;
  iban: string | null;
  bic: string | null;
  employeeNumber: string | null;
  position: string | null;
  employmentNature: string | null;
  employmentStart: string | null;
  trialPeriodEnd: string | null;
  employmentMunicipality: string | null;
  costPool: string | null;
  employmentPost: string | null;
  userFields: Array<{
    fieldId: string;
    value: string;
  }>;
  equipment: Array<{
    equipmentId: string;
    note: string;
  }>;
  salaries: Array<{
    type: string;
    salary: number;
    date: string;
  }>;
  languageProficiencies: Array<{
    language: string;
    level: string;
  }>;
  holidaysPerMonth: number;
  incrementedHolidays: number;
  availableHolidays: number;
  worktimeGroupId: string | null;
  departmentId: string | null;
  subDepartmentId: string | null;
}

const companyApi = {
  searchCompanies: async (query: string, hidePaywallCompanies: boolean): Promise<AxiosResponse<Company[]>> =>
    agent.get("/admin/company/search", {
      params: { query, hidePaywallCompanies },
    }),

  adminEdit: async (
    body: Pick<Company, "id" | "paywallActive" | "title"> & {
      permissions: CompanyPermissionId[];
    },
  ): Promise<AxiosResponse<Company[]>> => agent.put("/admin/company", body),

  delete: async (id: string): Promise<AxiosResponse<string>> => agent.delete(`/admin/company/${id}`),

  deleteMockData: async (companyId: string): Promise<AxiosResponse<string>> => agent.delete(`/mockdata/${companyId}`),

  generateMockData: async (companyId: string): Promise<AxiosResponse<string>> => agent.post(`/mockdata/${companyId}`),

  getImportData: async (id: string) =>
    agent.get<{
      userFields: CompanyUserField[];
      equipment: Equipment[];
      existingUsers: User[];
      worktimeGroups: WorktimeGroup[];
      departments: Department[];
    }>(`/admin/company/${id}/import`),

  importUser: async (companyId: string, data: ImportUserData) =>
    agent.post<{ userId: string }>(`/admin/company/${companyId}/import`, data),
};

export default companyApi;
